import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const ENV = process.env.REACT_APP_ENVIRONMENT || 'dev';

const configs = {
    dev: {
        apiKey: "AIzaSyD-rfTU01cDrKwyugWtQZBw9FMuOYbYpoM",
        authDomain: "assess-ai-prototype.firebaseapp.com",
        projectId: "assess-ai-prototype",
        storageBucket: "assess-ai-prototype.firebasestorage.app",
        messagingSenderId: "154403850959",
        appId: "1:154403850959:web:fad36ad12c84ecfb5ec5ba"
    },
    prod: {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID
    }
};

const firebaseConfig = configs[ENV] || configs.dev;

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
